module.exports = __webpack_public_path__ + "static/img/bg28.26ada2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg28.png
// module id = 5Ctj
// module chunks = 62